import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import NotFound from '../views/erros/NotFound.vue'
//import Home from '../views/Home.vue'
//PUBLICACAO
import Documentos from '@/views/Documentos.vue'
import DocumentoEdit from '@/views/DocumentoEdit.vue'
import DocumentoHtml from '@/views/DocumentoHtml.vue'
import Licitacoes from '@/views/Licitacoes.vue'
import LicitacaoEdit from '@/views/LicitacaoEdit.vue'
import Sancoes from '@/views/Sancoes.vue'
import SancaoEdit from '@/views/SancaoEdit.vue'
import SumulaEdit from '@/views/SumulaEdit.vue'
import Sumulas from '@/views/Sumulas.vue'
import Convenios from '@/views/Convenios.vue'
import ConvenioEdit from '@/views/ConvenioEdit.vue'
import Health from '@/views/Health.vue'
//SGDP
import Prejulgados from '@/views/Prejulgados.vue'
import ExcertoEdit from '@/views/ExcertoEdit.vue'
import ExcertoDecisao from '@/views/ExcertoDecisao.vue'
//MURAL
import MuralDocumentos from '@/views/MuralDocumentos.vue'
import MuralLicitacoes from '@/views/MuralLicitacoes.vue'
import MuralPrejulgados from '@/views/MuralPrejulgados.vue'
import MuralSancoes from '@/views/MuralSancoes.vue'
import MuralSumulas from '@/views/MuralSumulas.vue'
import MuralConvenios from '@/views/MuralConvenios.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Login,
    meta: {
      publica: true,
    },
  },
  {
    path:'/login',
    name: 'LOGIN',
    component: Login,
    meta: {
      publica: true,
    },
  },
  {
    path:'/home',
    name: 'HOME',
    component: Home
  },
  //PUBLICACAO
   /*{
    path:'/documentos',
    component: Documentos
  },
  
  {
    path: '/documentos/:id',
    name: 'DocumentoEdit',
    component: DocumentoEdit
  }, */
   {
    path:'/documentos/:pagina',
    name: 'DOCUMENTOS',
    component: Documentos,
    meta:{
      grupo: 'DOCUMENTOS',
    }
  },
  {
    path: '/documentos/:pagina/:id',
    name: 'DocumentoEdit',
    component: DocumentoEdit,
    meta:{
      grupo: 'DOCUMENTOS',
    }
  }, 
  {
    path: '/documentohtml/:id',
    name: 'DocumentoHtml',
    component: DocumentoHtml,
    meta: {
      publica: true,
    },
  },
  {
    path: '/licitacoes',
    name: 'LICITACOES',
    component: Licitacoes,
    meta:{
      grupo: 'LICITACOES',
    }
  },
  {
    path: '/licitacoes/:id',
    name: 'LicitacoesEdit',
    component: LicitacaoEdit,
    meta:{
      grupo: 'LICITACOES',
    }
  },
  {
    path: '/sancoes',
    component: Sancoes,
    meta:{
      grupo: 'SANCOES',
    }
  },
  {
    path: '/sancoes/:id',
    name: 'SancaoEdit',
    component: SancaoEdit,
    meta:{
      grupo: 'SANCOES',
    }
  },
  {
    path: '/sumulas',
    grupo: 'SUMULAS',
    component: Sumulas,
    meta:{
      grupo: 'SUMULAS',
    }
  },
  {
    path: '/sumulas/:id',
    name: 'SumulaEdit',
    component: SumulaEdit,
    meta:{
      grupo: 'SUMULAS',
    }
  },
  {
    path: '/convenios',
    component: Convenios,
    meta:{
      grupo: 'CONVENIOS',
    }
  },
  {
    path: '/convenios/:id',
    name: 'ConvenioEdit',
    component: ConvenioEdit,
    meta:{
      grupo: 'CONVENIOS',
    }
  },
  //MURAL
  {
    path:'/muraldocumentos',
    component: MuralDocumentos,
    meta: {
      publica: true,
    },
  },
  {
    path:'/murallicitacoes',
    component: MuralLicitacoes,
    meta: {
      publica: true,
    },
  },
  {
    path:'/muralprejulgados',
    component: MuralPrejulgados,
    meta: {
      publica: true,
    },
  },
  {
    path:'/muralsancoes',
    component: MuralSancoes,
    meta: {
      publica: true,
    },
  },
  {
    path:'/muralsumulas',
    component: MuralSumulas,
    meta: {
      publica: true,
    },
  },
  {
    path:'/muralconvenios',
    component: MuralConvenios,
    meta: {
      publica: true,
    },
  },
  //SGDP
  {
    path: '/prejulgados',
    name: 'PREJULGADOS',
    component: Prejulgados,
    meta:{
      grupo: 'PREJULGADOS',
    }
  },
  {
    path: '/prejulgados/:id',
    name: 'ExcertoEdit',
    component: ExcertoEdit,
    meta:{
      grupo: 'PREJULGADOS',
    }
  },
  {
    path: '/decisao/:id',
    name: 'ExcertoDecisao',
    component: ExcertoDecisao,
    meta: {
      publica: true,
    },
  },

  {
    path:'/notfound',
    component: NotFound,
    meta: {
      publica: true,
    },
  },
  {
    path:'*',
    redirect:'/notfound',
    meta: {
      publica: true,
    },
  },
  {
    path: "/health",
    component: Health,
    meta: {
      publica: true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      publica: true,
    },
  }

]




const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  //console.log(to)
  const loggedIn = localStorage.getItem('user');
  if (to.name != '/login' && !to.meta.publica) {
    if (loggedIn) {

      return next();
    }
    return next("/")
  }
  next();
});



export default router